import { validateForm } from '../main';

$(function () {
  $('.js-standardContact.overlay').appendTo('main');
  var $contactForm = $('.js-standardContact.overlay form');
  if ($contactForm.length === 1) {
    var $submitButton = $contactForm.find('button[type="submit"]');
    $submitButton.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (validateForm($contactForm)) {
        var data = $contactForm.serialize();
        $.ajax({
          url: $contactForm.attr('action'),
          type: 'POST',
          data: data,
          success: function (data) {
            var forwardSummary = $submitButton.data('summaryForward');
            if (forwardSummary) {
              //Direkte Weiterleitung auf eigenständige Dankesseite
              location.href = forwardSummary;
            } else {
              $('.js-standardContact.overlay').hide();
              $('.js-standardContactThanks').show();
            }
          },
          error: function (request, error) {
            alert($('.js-standardContact.overlay').attr('data-errormessage'));
          },
        });
      }
    });
  }

  $('.js-standardContact.overlay .callbackwish input').change(function () {
    var $checkbox = $(this);
    var tel = $('.js-standardContact.overlay .tel');
    var callbackFrom = $('.js-standardContact.overlay .tel-from');
    var callbackUntil = $('.js-standardContact.overlay .tel-until');
    var inputs = tel.find('input');

    if ($checkbox[0].checked) {
      tel.addClass('show');
      callbackFrom.addClass('show');
      callbackUntil.addClass('show');
      inputs.attr('required', 'required');
    } else {
      tel.removeClass('show');
      callbackFrom.removeClass('show');
      callbackUntil.removeClass('show');
      inputs.removeAttr('required');
    }
  });

  $('.js-standardContact.overlay .is-customer input').change(function () {
    var $checkbox = $(this);
    var accountContainer = $('.account', $(this).closest('.js-standardContact.overlay'));
    if ($checkbox[0].checked) {
      accountContainer.addClass('show');
      accountContainer.find('input, select').attr('required', 'required');
    } else {
      accountContainer.removeClass('show');
      accountContainer.find('input, select').removeAttr('required');
    }
  });

  $('.btn-contact').click(function () {
    $('.js-standardContact.overlay').show();
  });

  $('.js-standardContact.overlay .form-close, .js-standardContactThanks.overlay .form-close').click(
    function () {
      $('.js-standardContact.overlay').hide();
      $('.js-standardContactThanks').hide();
    }
  );

  $('.js-standardContact, .js-contact-component, .js-contact-modal').each(function () {
    var $this = $(this);
    var $selectFilialId = $this.find('.js-filialeDropdown');
    loadFilialData($selectFilialId.data('urlCsvFiliale'));
    function loadFilialData(csvURL) {
      if (!csvURL) {
        return;
      }
      $.ajax({
        type: 'GET',
        url: csvURL,
        dataType: 'text',
        scriptCharset: 'utf-8',
        success: function (response) {
          $selectFilialId.empty();
          var $defaultOption = $('<option value="">&nbsp;</option>');
          $selectFilialId.append($defaultOption);
          var data = response.csvToArray({ rSep: '\n', fSep: ';' });
          if (typeof data[0] === 'undefined') {
            console.error('Fatal Error: unable to determine csv zip data' + csvURL);
            return null;
          } else {
            const filialData = data;
            $.each(filialData, function (index, row) {
              if (row.length >= 3) {
                var filialId = row[0].replace('\r', '');
                var email = row[1].replace('\r', '');
                var name = row[2].replace('\r', '');

                var $optionField = $('<option value="' + email + '">' + name + '</option>');
                $selectFilialId.append($optionField);
              } else {
                console.error('Fatal Error: Invalid csv zip-Data format');
              }
            });
          }
        },
      });
    }
  });

  var $contactSuccessContainer = $('.js-standardContactThanks');
  var $successButton = $contactSuccessContainer.find('.js-contactSuccessForward');
  $successButton.on('click', function (e) {
    var forwardSummary = $(this).data('summaryForward');
    if (forwardSummary) {
      //Direkte Weiterleitung auf eigenständige Dankesseite
      location.href = forwardSummary;
    }
  });
});
